import { render, staticRenderFns } from "./hotel_details.vue?vue&type=template&id=e8b97332&scoped=true&"
import script from "./hotel_details.vue?vue&type=script&lang=js&"
export * from "./hotel_details.vue?vue&type=script&lang=js&"
import style0 from "./hotel_details.vue?vue&type=style&index=0&id=e8b97332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b97332",
  null
  
)

export default component.exports